export const TOGGLE_DISABLE_LAST_END_DATE_LABEL = 'Enable null end date';
